module.exports = "<ss-multiselect-dropdown [options]=\"options\" [texts]=\"msTexts\" [settings]=\"msSettings\"\n                         (ngModelChange)=\"valueChanged($event)\"\n                         [(ngModel)]=\"optionsModel\"></ss-multiselect-dropdown>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/multiselect-dropdown/multiselect-dropdown.component.html
// module id = 570
// module chunks = 0